
Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.Builder = {

    action: 'create',
    releasedDate: null,
    closedDate: null,
    surveyID: '',
    surveyBuilded: false,

    buildSurveyForUpdate: function () {
        this.action = 'update';

        const survey = this.buildSurvey();

        return survey;
    },

    buildSurvey: function () {
        this.surveyBuilded = true;
        
        this.buildQuestionsLink();

        return this.buildSections();
    },

    buildSections: function () {

        var sections         = Greenmile.Survey.Data.surveyData,
            sectionsToReturn = [],
            allQuestions     = [],
            i;

        if (sections) {

            for (i = 0; i < sections.length; i++) {

                var section = sections[i];
                var sectionObject = this.buildSingleSection(section);
                sectionsToReturn.push(sectionObject);

                allQuestions = allQuestions.concat(sectionObject.surveyQuestions);

            }

        }

        return sectionsToReturn;

    },

    buildSingleSection: function (section) {

        var sectionTitle    = section.el.querySelector('[name*="survey_section_title_"]'),
            questions       = section.surveyQuestions,
            question,
            parsedQuestion,
            sectionToReturn = {},
            parsedQuestions = [],
            i;

        if (questions) {

            for (i = 0; i < questions.length; i++) {

                question = questions[i];

                // when saving survey, delete what is on questions toDelete
                if (question.toDelete){
                    question.toDelete.forEach((answer) => {
                        Greenmile.Survey.Edit.deleteSurveyQuestionDomain(answer);
                    });
                }

                parsedQuestion = this.buildSingleQuestion(question);
                parsedQuestions.push(parsedQuestion);

            }

        }

        if (this.action === 'update' && section.isNew !== true) {

            sectionToReturn.id = section.id;

        }

        sectionToReturn.sectionOrder = section.order;
        sectionToReturn.title = sectionTitle.value;
        sectionToReturn.surveyQuestions = parsedQuestions;
        sectionToReturn.key = section.key;

        return sectionToReturn;

    },

    buildSingleQuestion: function (question) {
        
        var questionType        = question.el.getAttribute('questiontype'),
            questionDescription = question.el.querySelector('.newQuestionDescription'),
            isMandatory         = question.el.querySelector(`#Survey_isMandatory-${question.id} .checkBoxField`),
            requirePhoto        = question.el.querySelector(`#Survey_requirePhoto-${question.id} .checkBoxField`),
            isLoop              = question.el.querySelector(`#Survey_isLoop-${question.id} .checkBoxField`),
            isFinal             = question.el.querySelector(`#Survey_isFinal-${question.id} .checkBoxField`),
            questionObject      = question.questionObject || Greenmile.Survey.SidebarFactory.factoryItemFromJsonType(questionType),
            content             = null,
            questionToReturn    = {};

        if (questionObject.serializeContent) {
            content = questionObject.serializeContent(question);
        }

        if (this.action === 'update' && question.isNew !== true) {
            questionToReturn.id = question.id;
        }

        if (question.nextQuestion) {
            questionToReturn.nextQuestion = question.nextQuestion;
        }

        questionToReturn.surveyQuestionDomain = content;
        questionToReturn.mandatory = isMandatory.checked;
        questionToReturn.requirePhoto = requirePhoto.checked;
        questionToReturn.loopQuestion = (isLoop ? isLoop.checked : false);
        questionToReturn.finishSurvey = (isFinal ? isFinal.checked : null);
        questionToReturn.type = questionObject.jsonType;
        questionToReturn.question = questionDescription.innerHTML;
        questionToReturn.key = question.key;
        questionToReturn.subQuestions = question.subQuestions;
        questionToReturn.entity = question.entity;
        questionToReturn.entityProjection = question.entityProjection;
        questionToReturn.entityRestriction = question.entityRestriction;
        questionToReturn.defaultAnswer = question.defaultAnswer;
        questionToReturn.entityAvoidDuplicateSelection = question.entityAvoidDuplicateSelection;
        questionToReturn.questionOrder = question.order;

        // set survey action attributes
        const { generateTask, jsonParameter } = Greenmile.Survey.Data.getSurveyQuestionActionAttributes(question.id);
        questionToReturn.generateTask = !!generateTask;
        questionToReturn.jsonParameter = JSON.stringify(jsonParameter);

        return questionToReturn;
    },

    buildQuestionsLink: function () {

        var links = Greenmile.Survey.Form.linkedQuestions,
            link,
            sourceAnswer,
            sourceQuestion,
            linkSection,
            linkQuestion,
            nextQuestion,
            i;

        for (i = 0; i < links.length; i++) {

            link = links[i];
            sourceQuestion = Greenmile.Survey.Data.findQuestion(link.questionId);
            linkQuestion = Greenmile.Survey.Data.findQuestion(link.link.value);
            linkSection = Greenmile.Survey.Data.getSectionForQuestion(link.link.value);
            sourceAnswer = null;

            nextQuestion = {

                key: linkQuestion.key,

                surveySection: {

                    key: linkSection.key
                }

            };

            if (this.action === 'update') {

                if (linkQuestion.isNew !== true) {

                    nextQuestion.id = linkQuestion.id;

                }

                if (linkSection.isNew !== true) {

                    nextQuestion.surveySection.id = linkSection.id;

                }

            }

            if (link.linkType === Greenmile.Survey.Link.answerLinkType) {

                sourceAnswer = Greenmile.Survey.Data.findQuestionDomain(sourceQuestion, link.answerId);
                sourceAnswer.nextQuestion = nextQuestion;

            } else {

                sourceQuestion.nextQuestion = nextQuestion;

            }

        }

    }

};
